import { render, staticRenderFns } from "./ManageModel.vue?vue&type=template&id=24c6317e&scoped=true"
import script from "./ManageModel.vue?vue&type=script&lang=js"
export * from "./ManageModel.vue?vue&type=script&lang=js"
import style0 from "./ManageModel.vue?vue&type=style&index=0&id=24c6317e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c6317e",
  null
  
)

export default component.exports